var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("pz-form-flujo", {
    attrs: {
      "available-captcha": _vm.extraData.withCaptcha,
      forward: _vm.handleSave,
      backwards: _vm.showBack ? _vm.handleBack : null
    },
    model: {
      value: _vm.formulario2["captcha"],
      callback: function callback($$v) {
        _vm.$set(_vm.formulario2, "captcha", $$v);
      },
      expression: "formulario2['captcha']"
    }
  }, [_c("span", {
    attrs: {
      slot: "form_title"
    },
    slot: "form_title"
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.form2_persona.UY.title")) + " ")]), _c("el-form", {
    ref: _vm.reference,
    attrs: {
      slot: "formulario",
      "label-position": "top",
      model: _vm.formulario2,
      "status-icon": "",
      rules: _vm.rules_formulario2
    },
    slot: "formulario"
  }, [_c("pz-direction", {
    attrs: {
      "ask-postal-code": "",
      step: "2"
    },
    model: {
      value: _vm.formulario2.direccion,
      callback: function callback($$v) {
        _vm.$set(_vm.formulario2, "direccion", $$v);
      },
      expression: "formulario2.direccion"
    }
  }), _c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("hr", {
    staticClass: "pz-dotted"
  })]), _c("el-row", {
    staticClass: "pz-large-margin",
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    staticClass: "row justify-content-center",
    attrs: {
      span: 24
    }
  }, [_c("b", {
    staticClass: "pz-font-size-lg"
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.form2_persona.UY.entrega")) + " ")])])], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      xl: {
        span: 12
      },
      lg: {
        span: 12
      },
      md: {
        span: 12
      },
      sm: {
        span: 24
      },
      xs: {
        span: 24
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "tipo_entrega",
      label: _vm.$t("forms_flujo.form2_persona.UY.tipo_entrega"),
      error: _vm.errors.get("tipo_entrega")
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.formulario2.info_extra.tipo_entrega,
      callback: function callback($$v) {
        _vm.$set(_vm.formulario2.info_extra, "tipo_entrega", $$v);
      },
      expression: "formulario2.info_extra.tipo_entrega"
    }
  }, [_c("el-radio", {
    attrs: {
      label: "1",
      border: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("tipo_entrega.envio_domicilio")) + " ")]), _c("el-radio", {
    attrs: {
      label: "2",
      border: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("tipo_entrega.retiro_sucursal")) + " ")])], 1)], 1)], 1), _vm.formulario2.info_extra.tipo_entrega == 2 ? _c("el-col", {
    attrs: {
      xl: {
        span: 12
      },
      lg: {
        span: 12
      },
      md: {
        span: 12
      },
      sm: {
        span: 24
      },
      xs: {
        span: 24
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      prop: "tipo_sucursal",
      label: _vm.$t("forms_flujo.form2_persona.UY.tipo_sucursal"),
      error: _vm.errors.get("tipo_sucursal")
    }
  }, [_c("el-radio-group", {
    model: {
      value: _vm.formulario2.info_extra.tipo_sucursal,
      callback: function callback($$v) {
        _vm.$set(_vm.formulario2.info_extra, "tipo_sucursal", $$v);
      },
      expression: "formulario2.info_extra.tipo_sucursal"
    }
  }, [_c("el-radio", {
    attrs: {
      label: "1",
      border: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.form2_persona.UY.nombre_sucursal.montevideo")) + " ")]), _c("el-radio", {
    attrs: {
      label: "2",
      border: ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("forms_flujo.form2_persona.UY.nombre_sucursal.interior")) + " ")])], 1)], 1)], 1) : _vm._e()], 1), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_vm.formulario2.info_extra.tipo_entrega == 1 ? _c("pz-direction", {
    attrs: {
      "ask-postal-code": "",
      step: "2"
    },
    model: {
      value: _vm.formulario2.info_extra.direccion_entrega,
      callback: function callback($$v) {
        _vm.$set(_vm.formulario2.info_extra, "direccion_entrega", $$v);
      },
      expression: "formulario2.info_extra.direccion_entrega"
    }
  }) : _vm._e()], 1), _vm.formulario2.info_extra.tipo_entrega == 2 && _vm.formulario2.info_extra.tipo_sucursal == 1 ? _c("el-row", {
    staticClass: "pz-large-margin",
    attrs: {
      gutter: 20
    }
  }, _vm._l(_vm.activities2, function (value, index) {
    return _c("el-col", {
      key: index,
      staticClass: "row justify-content-center",
      attrs: {
        span: 24
      }
    }, [_c("div", [_c("strong", {
      staticClass: "pz-color-primary"
    }, [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(value) + " ")])]);
  }), 1) : _vm.formulario2.info_extra.tipo_entrega == 2 && _vm.formulario2.info_extra.tipo_sucursal == 2 ? _c("el-row", {
    staticClass: "pz-large-margin",
    attrs: {
      gutter: 20
    }
  }, _vm._l(_vm.activities3, function (value, index) {
    return _c("el-col", {
      key: index,
      staticClass: "row justify-content-center",
      attrs: {
        span: 24
      }
    }, [_c("div", [_c("strong", {
      staticClass: "pz-color-primary"
    }, [_vm._v(_vm._s(index) + ":")]), _vm._v(" " + _vm._s(value) + " ")])]);
  }), 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };